import styled, { keyframes, css } from 'styled-components'

export const TabBoxWrapper = styled.div<{ isValid: boolean }>`
  ${({ theme, isValid }) => css`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding-top: 24px;

    > .double-arrow-icon {
      ${isValid &&
      css`
        animation: ${slideRight} 0.6s ease-in-out 0s 2;
        path {
          fill: ${theme.ds.colors.primary600};
        }
      `}
    }
  `}
`

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

// Slide to right animation
const slideRight = keyframes`
  0% { transform: translateX(0); }
  50% { transform: translateX(8px); }
  100% { transform: translateX(0); }
`

export const PersonalizedTextError = styled.p`
  position: absolute;
  top: calc(100% + 4px);
  font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
  color: ${({ theme }) => theme.ds.colors.danger300};
  left: 0;
`
